import { Button } from "@/components/ui/button"

interface PaginationControlsProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

export function PaginationControls({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationControlsProps) {
  if (totalPages <= 1) return null

  return (
    <div className="flex items-center justify-center gap-3 border-t border-border p-3 sm:gap-4 sm:p-4">
      <Button
        variant="outline"
        size="sm"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="w-20 text-xs sm:w-auto sm:text-sm bg-transparent"
      >
        上一页
      </Button>
      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground">
          第 {currentPage} / {totalPages} 页
        </span>
      </div>
      <Button
        variant="outline"
        size="sm"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className="w-20 text-xs sm:w-auto sm:text-sm bg-transparent"
      >
        下一页
      </Button>
    </div>
  )
}
